import React, { createContext, useState, useContext } from 'react' // Tambahkan useContext di sini

export const AuthContext = createContext()

// 1. Tambahkan Custom Hook di sini
export const useAuth = () => {
    return useContext(AuthContext)
}

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("isLoggedIn"))

    const login = () => {
        localStorage.setItem("isLoggedIn", "true")
        setIsLoggedIn(true)
    }

    const logout = () => {
        localStorage.removeItem("isLoggedIn")
        setIsLoggedIn(false)
        window.location.replace('/')
    }

    return (
        <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
            {children}
        </AuthContext.Provider>
    )
}